import { Slider as BaseSlider, SliderFilledTrack, SliderProps, SliderTrack } from '@chakra-ui/react';
import { FC } from 'react';

const Slider: FC<SliderProps> = props => {
  return (
    <BaseSlider {...props}>
      <SliderTrack bg="secondary.300">
        <SliderFilledTrack bg="other.CTA" />
      </SliderTrack>
    </BaseSlider>
  );
};

export default Slider;
